/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExecuteBcrMatchesReportMutationRequest, AuditReportsExecuteBcrMatchesReportMutationResponse, AuditReportsExecuteBcrMatchesReportQueryParams, AuditReportsExecuteBcrMatchesReport400, AuditReportsExecuteBcrMatchesReport401, AuditReportsExecuteBcrMatchesReport403, AuditReportsExecuteBcrMatchesReport500 } from "../models/AuditReportsExecuteBcrMatchesReport";

export function getAuditReportsExecuteBcrMatchesReportUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/bcr-matches/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /audit-reports/v1/reports/bcr-matches/results}
 */
export async function auditReportsExecuteBcrMatchesReport(data: AuditReportsExecuteBcrMatchesReportMutationRequest, params?: AuditReportsExecuteBcrMatchesReportQueryParams, config: Partial<RequestConfig<AuditReportsExecuteBcrMatchesReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsExecuteBcrMatchesReportMutationResponse, ResponseErrorConfig<AuditReportsExecuteBcrMatchesReport400 | AuditReportsExecuteBcrMatchesReport401 | AuditReportsExecuteBcrMatchesReport403 | AuditReportsExecuteBcrMatchesReport500>, AuditReportsExecuteBcrMatchesReportMutationRequest>({ method : "POST", url : getAuditReportsExecuteBcrMatchesReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}